exports = module.exports = require("../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#app{font-family:Helvetica,sans-serif}#app .Copyright{color:#888;text-align:center;font-size:12px;padding:10px 20px}img{width:100%}a{text-decoration:none;color:#000}@media screen and (min-width:900px){#app{width:700px;margin:0 auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c76d2a7","scoped":false,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 173
// module chunks = 1